import config from "./config";
var axios = config();

export default {
  getSite(id) {
    return axios.get("/api/Sites/GetSiteById", { params: { id: id } });
  },

  getSites() {
    return axios.get("/api/Sites/GetSitesActive", {});
  },

  getSitesByUser() {
    return axios.get("/api/Sites/GetSitesByUser", {});
  },

  getSiteContractRequirementTypes() {
    return axios.get("/api/Sites/GetActiveSiteRequirements", {});
  },

  getSitesWithNoContract() {
    return axios.get("/api/Sites/GetSitesWithNoContract", {});
  },

  getSiteNotes(siteId) {
    return axios.get("/api/Sites/GetActiveSiteNotes", {
      params: { id: siteId }
    });
  },

  getSiteContact(contactId) {
    return axios.get("/api/Sites/GetSiteContactById", {
      params: { id: contactId }
    });
  },

  getSiteFiles(siteId) {
    return axios.get("/api/Sites/GetActiveSiteFiles", {
      params: { id: siteId }
    });
  },

  getSiteSupervisors(siteId) {
    return axios.get("/api/Sites/GetSiteSupervisors", {
      params: { siteId: siteId }
    });
  },
  getSiteSupervisorsByStudentOpportunity(studentOpportunityId) {
    return axios.get("/api/Sites/getSiteSupervisorsByStudentOpportunity", {
      params: { studentOpportunityId: studentOpportunityId }
    });
  },

  postSite(site) {
    return axios.post("/api/Sites/AddSite", site);
  },

  postEditSite(site) {
    return axios.post("/api/Sites/EditSite", site);
  },

  postSiteContact(contact) {
    return axios.post("/api/Sites/AddSiteContact", contact);
  },

  postEditSiteContact(contact) {
    return axios.post("/api/Sites/EditSiteContact", contact);
  },

  postSiteWithRequest(site, request) {
    return axios.post("/api/Sites/AddSiteWithRequest", {
      site: site,
      request: request
    });
  },

  postSiteNote(siteId, note) {
    return axios.post("/api/Sites/AddSiteNote", {
      SiteId: siteId,
      Notes: note
    });
  },

  postSiteFile(formData, files) {
    return axios({
      method: "POST",
      url: "/api/Sites/AddSiteFile",
      transformRequest: function(data) {
        var formData = new FormData();
        // need to convert our json object to a string version of json otherwise
        // the browser will do a 'toString()' on the object which will result
        // in the value '[Object object]' on the server.
        formData.append("data", JSON.stringify(data.data));
        //now add all of the assigned files
        for (var i = 0; i < data.files.length; i++) {
          //add each file to the form data and iteratively name them
          formData.append("file" + i, data.files[i]);
        }
        return formData;
      },
      data: { data: formData, files: files } // pass in data as strings
      //headers: { 'Content-Type': undefined }  // set the headers so angular passing info as form data (not request payload)
    });
  },

  deleteSiteContact(siteContactId) {
    return axios.delete("/api/Sites/DeleteSiteContact/" + siteContactId);
  },

  deleteSite(siteDeletion) {
    return axios.post("/api/Sites/DeleteSite", siteDeletion);
  }
};
